































































































































interface Fee {
    type?: string;
    isSelect: boolean;
    isOther?: boolean;
    dateFrom: Date | string;
    dateTo: Date | string;
    discount: number;
    shouldFee: number;
    totalFee?: number;
    remark?: string;
    tmp: number;
}
interface total {
    fee: number;
    balance: number;
    realGet: number;
    useBalance: boolean;
}
interface packCharge {
    chargeType: string;
    startPeriod: string;
    endPeriod: string;
    countCharge: string;
    discountCharge: string;
    remark?: string;
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
import ChargeTypeInnerVue from "./ChargeTypeInner.vue";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "charge-type-inner": ChargeTypeInnerVue
    }
})
export default class ChargeInfo extends Vue {
    @Prop({ type: Object })
    bookData?: Charge.Charge;

    // pickerOptions初值为空对象,因为还未获取到限制的时间
    disabledDate: DatePickerOptions = {};

    payVal: string = "现金"; //收费方式
    payments: string[] = ["银行--对公", "银行--对人", "现金", "支付宝", "微信"]; //收费选项
    chargeDate: Date = new Date(); //收费日期
    //记账费
    accountFee: Fee = {
        type: "记账费",
        isSelect: true,
        dateFrom: "",
        dateTo: "",
        discount: 0,
        shouldFee: 0,
        totalFee: 0,
        tmp: 0
    };

    //账本费
    bookFee: Fee = {
        type: "账本费",
        isSelect: false,
        dateFrom: "",
        dateTo: "",
        discount: 0,
        shouldFee: 0,
        totalFee: 0,
        tmp: 0
    };

    //其他费
    otherFee: Fee = {
        isSelect: false,
        isOther: true,
        dateFrom: "",
        dateTo: "",
        discount: 0,
        remark: "",
        shouldFee: 0,
        tmp: 0
    };
    //合计费用
    total: total = {
        fee: 0,
        balance: 0,
        realGet: 0,
        useBalance: false
    };

    mounted() {
        if (this.bookData) {
            this.total.balance = this.bookData.chargeBalance;
        }
    }

    // 使用余额
    changeUseBal() {
    }
    //打包收费数组
    packChange(type: string) {
        let packData: packCharge = {
            chargeType: "",
            startPeriod: "",
            endPeriod: "",
            countCharge: "",
            discountCharge: ""
        };
        let from = this.accountFee;
        packData.chargeType = type;
        switch (type) {
            case "记账费": {
                from = this.accountFee;
                break;
            }
            case "账本费": {
                from = this.bookFee;
                break;
            }
            default: {
                from = this.otherFee;
            }
        }
        packData.startPeriod = this.$utils.simpleDateFormat(
            <Date>from.dateFrom,
            "m"
        );
        packData.endPeriod = this.$utils.simpleDateFormat(
            <Date>from.dateTo,
            "m"
        );
        packData.countCharge = from.shouldFee.toString();
        packData.discountCharge = from.discount.toString();
        if (type == "其他费用") {
            packData.remark = from.remark;
        }

        return packData;
    }

    // 清除保存数组的数据
    removeCharge(chargeBox: packCharge[]) {
        for (var i = 0; i++; i < chargeBox.length) {
            if (chargeBox[i].chargeType === "记账费") {
                chargeBox.splice(i, 1);
            }
            if (chargeBox[i].chargeType === "账本费") {
                chargeBox.splice(i, 1);
            }
            if (chargeBox[i].chargeType === "其他费用") {
                chargeBox.splice(i, 1);
            }
        }
    }
    // 数据不完整提醒
    messageWarn() {
        this.$message({
            type: "warning",
            message: "请填写完整信息！"
        });
        return;
    }
    // 保存
    save() {
        let chargeBox: packCharge[] = [],
            accountCopy: packCharge,
            bookCopy: packCharge,
            otherCopy: packCharge;
        try {
            if (this.accountFee.isSelect) {
                accountCopy = this.packChange("记账费");
                chargeBox.push(accountCopy);
            } else {
                if (chargeBox.length > 0) {
                    this.removeCharge(chargeBox);
                }
            }
            if (this.bookFee.isSelect) {
                bookCopy = this.packChange("账本费");
                chargeBox.push(bookCopy);
            } else {
                if (chargeBox.length > 0) {
                    this.removeCharge(chargeBox);
                }
            }
            if (this.otherFee.isSelect) {
                otherCopy = this.packChange("其他费用");
                chargeBox.push(otherCopy);
            } else {
                if (chargeBox.length > 0) {
                    this.removeCharge(chargeBox);
                }
            }
        } catch (e) {
            this.$message({
                type: "warning",
                message: "请填写完整信息！"
            });
            return;
        }
        if (this.bookData) {
            Vue.axios
                .post(`charge/create`, {
                    accountBookId: this.bookData.id,
                    chargeDate: this.$utils.simpleDateFormat(
                        this.chargeDate,
                        "d",
                        true
                    ),
                    paymentMethod: this.payVal,
                    totalCharge: this.total.fee,
                    actualCharge: this.total.realGet,
                    balanceCharge: this.total.useBalance
                        ? this.total.balance
                        : null,
                    chargeHistoryDetails: chargeBox
                })
                .then(res => {
                    this.total.realGet = 0;
                    this.accountFee.isSelect = true;
                    this.bookFee.isSelect = false;
                    this.otherFee.isSelect = false;
                    this.$emit("success");
                    this.$message({
                        type: "success",
                        message: "保存成功！"
                    });
                });
        }
    }
    close() {
        this.$emit("close");
    }

    @Watch("accountFee", { deep: true })
    accountFeeChange(val: Fee) {
        let fromYear: string = "",
            fromMonth: string = "",
            toYear: string = "",
            toMonth: string = "";
        if (val.dateTo != "" && val.dateFrom != "") {
            fromYear = this.$utils
                .simpleDateFormat(new Date(val.dateFrom), "d", true)
                .split("-")[0];
            fromMonth = this.$utils
                .simpleDateFormat(new Date(val.dateFrom), "d", true)
                .split("-")[1];
            toYear = this.$utils
                .simpleDateFormat(new Date(val.dateTo), "d", true)
                .split("-")[0];
            toMonth = this.$utils
                .simpleDateFormat(new Date(val.dateTo), "d", true)
                .split("-")[1];
        }
        let len = +toMonth - +fromMonth + (+toYear - +fromYear) * 12 + 1;
        if (this.bookData) {
            if (len >= 1 && val.dateTo != "" && val.dateFrom != "") {
                if (this.bookData.monthlyCharge != undefined)
                    val.shouldFee = +(
                        this.bookData.monthlyCharge * len
                    ).toFixed(2);
                val.totalFee = val.shouldFee - val.discount;
                this.total.fee = val.totalFee;
                if (!val.isSelect) this.total.fee -= val.totalFee;
                if (this.bookFee.isSelect) {
                    if (this.bookFee.totalFee != undefined)
                        this.total.fee += this.bookFee.totalFee;
                }
                this.total.realGet = this.total.fee;
            } else {
                val.shouldFee = 0;
                val.totalFee = 0;
            }
        }
    }

    @Watch("bookFee", { deep: true })
    bookFeeChange(val: Fee) {
        if (this.bookData) {
            let len =
                Math.floor(
                    (new Date(val.dateTo).getTime() -
                        new Date(val.dateFrom).getTime()) /
                    (24 * 60 * 60 * 1000 * 30)
                ) + 1;

            if (len >= 1 && val.dateTo != "" && val.dateFrom != "") {
                let monthFee = this.bookData.annualCharge / 12;
                val.shouldFee = +(len * monthFee).toFixed(2);

                val.totalFee = val.shouldFee - val.discount;
                this.total.fee = val.totalFee;
                if (!val.isSelect) this.total.fee -= val.totalFee;
                if (this.accountFee.isSelect) {
                    if (this.accountFee.totalFee != undefined)
                        this.total.fee += this.accountFee.totalFee;
                }
                this.total.realGet = this.total.fee;
            } else {
                val.shouldFee = 0;
                val.totalFee = 0;
            }
        }
    }

    @Watch("otherFee", { deep: true })
    otherFeeChange(val: Fee) {
        val.totalFee = val.shouldFee - val.discount;
        this.total.fee = val.totalFee;
        if (!val.isSelect) this.total.fee -= val.totalFee;
        this.changeTotalFee();
        this.total.realGet = this.total.fee;
    }

    changeTotalFee() {
        if (this.bookFee.isSelect) {
            if (this.bookFee.totalFee != undefined)
                this.total.fee += this.bookFee.totalFee;
        }
        if (this.accountFee.isSelect) {
            if (this.accountFee.totalFee != undefined)
                this.total.fee += this.accountFee.totalFee;
        }
    }
}
